<template>
  <c-modal :active="displayModal" :title="title" @close="close">
    <form @submit.prevent="submit">
      <c-input
        v-model="name"
        floating-label="Название категории"
        :max-length="255"
        :required="isSubmitted && nameError"
        :required-condition="isSubmitted && nameError"
        :class="{ 'is-invalid': isSubmitted && nameError }"
      />
    </form>

    <template #actions>
      <c-button
        size="large"
        class="reference-reasons-for-bonuses-create-modal__actions__reset"
        label="Отменить"
        @click="close"
      />
      <c-button
        class="reference-reasons-for-bonuses-create-modal__actions__save"
        label="Сохранить"
        color="primary"
        size="large"
        @click="submit"
      />
    </template>
  </c-modal>
</template>

<script>
import CInput from "@/components/controls2/Input";
import CButton from "@/components/controls2/Button";
import CModal from "@/components/scrollable-modal";
import { REQUIRED_ERROR } from "@/constants/errorFieldValues";
import { CREATE_CATEGORY_ACTION, EDIT_CATEGORY_ACTION } from '../utils/actions';

export default {
  name: "bonuses-category-create-modal",
  components: {
    CInput,
    CButton,
    CModal,
  },
  props: ["code"],
  data() {
    return {
      displayModal: false,
      isSubmitted: false,
      pending: false,
      category: null,
      name: "",
    };
  },
  computed: {
    title() {
      return this.category ? "Редактировать категорию" : "Создать категорию";
    },
    nameError() {
      return this.name.trim() ? false : REQUIRED_ERROR;
    },
    isValid() {
      return !this.nameError;
    },
  },

  methods: {
    open(data) {
      if (data) this.setData(data);
      this.displayModal = true;
    },

    setData(data) {
      this.category = data;
      this.name = data.name;
    },

    close() {
      this.displayModal = false;
      this.reset();
      this.$emit("close");
    },

    reset() {
      this.isSubmitted = false;
      this.isPending = false;
      this.category = null;
      this.name = "";
    },

    getParams() {
      const params = {
        name: this.name,
        code: this.code,
      };
      if (this.category) {
        params.categoryId = this.category.id;
      }
      return params;
    },

    submit() {
      this.isSubmitted = true;
      if (!this.isValid) {
        return;
      }

      this.pending = true;

      const action = this.category ? EDIT_CATEGORY_ACTION : CREATE_CATEGORY_ACTION;

      this.$store.dispatch(action, this.getParams()).then((response) => {
        this.pending = false;
        if (response.success) {
          this.$emit(this.category ? "updated" : "created", response.model);
          this.close();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

.is-invalid {
  padding-bottom: 25px;
}
</style>
